import {Component} from '@angular/core';
import {ThrobberService} from '../../_services/throbber.service';


@Component({
  selector: 'throbber',
  standalone: false,
  template: `
    <div class="overlay-throbber" *ngIf="show">
      <div class="throbber-contenedor">
        <div style="position: absolute; top: 50%; left: 50%; margin-left: -100px; margin-top: -100px;">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    </div>`,
  styleUrls: ['./throbber.component.scss']
})

export class ThrobberComponent {
  public show: boolean = false;

  constructor(private throbServ: ThrobberService) {
  }

  ngOnInit() {
    this.throbServ.getThrobber().subscribe(estado => {
      this.show = estado.estado;
    });
  }
}
